
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { DropDown } from '@mg/micro/vue2'
import HeaderUserSigned from '~/components/header/HeaderUserSigned.vue'
import HeaderUserUnsigned from '~/components/header/HeaderUserUnsigned.vue'
import {
  GQLLocalAccount,
  GQLLocalOpenHeaderEnum,
} from '~/graphql/__generated__/interfacesLocal'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'

@Component({
  apollo: {
    account: {
      fetchPolicy: 'cache-only',
      query: GQL_LOCAL_ACCOUNT,
    },
  },
  components: { DropDown, HeaderUserSigned, HeaderUserUnsigned },
})
export default class HeaderUser extends Vue {
  @Prop({ default: 'right', type: String }) dropDownPosition: 'left' | 'right'
  @Prop({ default: false, type: Boolean }) isOpenState: boolean = false
  @Prop({ default: false, type: Boolean }) disableUserLink!: boolean

  account: GQLLocalAccount

  @Emit('changeTab')
  changeTab(tabName: null | GQLLocalOpenHeaderEnum) {
    return tabName
  }

  @Emit()
  closeTab() {}

  get isLoggedIn() {
    return !!this.$shopConfig.user.id || !!this.account?.isLogged
  }
}
